import styled, { keyframes } from 'styled-components';

const SlideUp = keyframes`
  0% {
    height: 0;
  }
  100% {
    height: 15rem;
  }`;

export const Animate = keyframes`
  0% {
      transform: translateY(0) rotate(0deg);
      opacity: 1;
      border-radius: 0;
   }
   100% {
      transform: translateY(-1000px) rotate(720deg);
      opacity: 0;
      border-radius: 50%;
   }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const Circles = styled.ul`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
`;
export const Circle = styled.li`
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  animation: ${Animate} 25s linear infinite;
  bottom: -150px;

  &:nth-child(1) {
    left: 25%;
    width: 80px;
    height: 80px;
    animation-delay: 0s;
  }
  &:nth-child(2) {
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 2s;
    animation-duration: 12s;
  }
  &:nth-child(3) {
    left: 70%;
    width: 20px;
    height: 20px;
    animation-delay: 4s;
  }
  &:nth-child(4) {
    left: 40%;
    width: 60px;
    height: 60px;
    animation-delay: 0s;
    animation-duration: 18s;
  }
  &:nth-child(5) {
    left: 75%;
    width: 110px;
    height: 110px;
    animation-delay: 3s;
  }
  &:nth-child(6) {
    left: 35%;
    width: 150px;
    height: 150px;
    animation-delay: 7s;
  }
  &:nth-child(7) {
    left: 50%;
    width: 25px;
    height: 25px;
    animation-delay: 15s;
    animation-duration: 45s;
  }
  &:nth-child(8) {
    left: 20%;
    width: 15px;
    height: 15px;
    animation-delay: 2s;
    animation-duration: 35s;
  }
  &:nth-child(9) {
    left: 85%;
    width: 150px;
    height: 150px;
    animation-delay: 0s;
    animation-duration: 11s;
  }
`;

export const CenterContent = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;

    position: absolute;
    top: 0;
    bottom: unset;
    left: unset;
    height: 100vh;
    right: unset;
    transform: none;
    .centertext {
      z-index: 2;
    }
    .overlay {
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1;
    }
  }
`;

export const TextSide = styled.div`
  color: #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  position: relative;
  z-index: 2;
  width: 800px;
  min-width: 800px;
  margin: auto;
  gap: 30px;

  .center {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }

  .preview-link {
    /* text-decoration: underline; */
    cursor: pointer;
    /* letter-spacing: 0.1rem; */
    /* transition: all 0.3s ease-in-out; */
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    margin: auto;
    min-width: unset;
  }
`;
export const Title = styled.h1`
  font-size: 68px;
  @media screen and (min-width: 1920px) {
    font-size: 45px;
  }
  @media screen and (max-width: 768px) {
    font-size: 28px;
    margin: 0;
  }
`;
export const SubTitle = styled.p`
  width: 85%;
  margin: auto;
  line-height: 150%;
  span {
    letter-spacing: 110%;
    font-style: italic;
  }
`;

export const AnimateOne = keyframes`
0%{
  transform: translateX(-100%);
}
100%{
  transform: translateX(100%);
}`;
export const AnimateTwo = keyframes`
0%{
  transform: translateY(-100%);
}
100%{
  transform: translateY(100%);
}`;
export const AnimateThree = keyframes`
0%{
  transform: translateX(100%);
}
100%{
  transform: translateX(-100%);
}`;
export const AnimateFour = keyframes`
0%{
  transform: translateY(100%);
}
100%{
  transform: translateY(-100%);
}`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 0.5rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.2rem;
  margin-top: 1rem;
  transition: all 0.5s ease;
  background: rgb(25, 69, 71);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
  background: #f1f1f1;
  color: #000;
  .icon {
    margin-right: 0.5rem;
  }
  span {
    border-radius: 2px;
  }
  span:nth-child(1) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to left, #f1f1f1, rgba(21, 32, 43, 1));

    animation: ${AnimateOne} 2s linear infinite;
  }
  span:nth-child(2) {
    position: absolute;
    top: 0;
    right: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(to top, #f1f1f1, rgba(21, 32, 43, 1));

    animation: ${AnimateTwo} 2s linear infinite;
    animation-delay: 1s;
  }
  span:nth-child(3) {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #f1f1f1, rgba(21, 32, 43, 1));
    animation: ${AnimateThree} 2s linear infinite;
  }
  span:nth-child(4) {
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
    background: linear-gradient(to bottom, #f1f1f1, rgba(21, 32, 43, 1));
    animation: ${AnimateFour} 2s linear infinite;
    animation-delay: 1s;
  }
`;

export const ImageSide = styled.div`
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-position: center;
  height: 100vh;
  position: relative;

  .image-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(-90deg, rgba(0, 0, 0, 0.01) 0%, #15202b 95%);
  }

  @media screen and (max-width: 768px) {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: none;
  }
`;

export const HandleWrapper = styled.div`
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 30vw;
  // height: 40vh;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);

  animation: ${SlideUp} 1s linear;

  @media screen and (max-width: 900px) {
    width: 90%;
  }
`;
export const Content = styled.div``;
export const Text = styled.p`
  color: #f1f1f1;
  font-size: 1.2rem;
  font-weight: bold;
`;
export const Form = styled.form``;
export const Input = styled.input`
  caret-color: #f1f1f1;
  height: 30px;
  border-bottom: thin solid #194547;
  padding-left: 10px;
  margin: 1rem;
  transition: all 1s linear;
  color: #f1f1f1;
  font-weight: bold;
  &:focus {
    border-bottom: 1px solid #fdfbfb;
    border-bottom: ${(props) =>
      !props.allGood ? '1px solid red' : '1px solid #fdfbfb'};
  }
  &::placeholder {
    opacity: 0.5;
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
`;
export const ButtonHandle = styled.button`
  width: 120px;
  height: 40px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s linear;
  font-weight: 500;
  &:disabled {
    cursor: default;
  }
`;

export const Div = styled.section`
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  max-height: 100vh;
`;
